import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress",
  style: {"height":"6px"}
}
const _hoisted_2 = ["aria-valuenow"]

import AppIcon from "@/components/app/AppIcon.vue";

interface Props {
  progressCurrent?: number,
  progressTotal?: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoadingMessage',
  props: {
    progressCurrent: { default: 0 },
    progressTotal: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { progressCurrent: number, progressTotal: number };




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppIcon, {
      icon: "spinner",
      spin: "",
      style: {"margin-right":"4px"}
    }),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode("Loading")
    ]),
    _createTextVNode(" ... "),
    (props.progressTotal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "progress-bar progress-bar-animated progress-bar-striped bg-info",
            "aria-valuenow": Math.round(100 * props.progressCurrent / props.progressTotal),
            style: _normalizeStyle({ width: `${Math.round(100 * props.progressCurrent / props.progressTotal)}%` })
          }, null, 12, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})